module.exports = __webpack_public_path__ + "img/Alexis-Erickson.7c989e48.jpg";